<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <pageheader :page-name="pageName" parent-page-name="Products" parent-page-url="/products" />
      <add-edit-form
        v-if="model"
        returnUrl="/products"
        :apiBaseUrl="API_BASE_URL"
        :model="model"
        :fields="fields"
        :toEdit="toEdit"
      />
    </div>
    <!-- Content Wrapper END -->
  </div>
</template>

<script>
import Pageheader from '@/components/Pageheader.vue'
import AddEditForm from '@/components/AddEditForm.vue'
import Product from '@/models/Product'
/* eslint-disable no-undef */
export default {
  name: 'AddProduct',
  components: {
    Pageheader,
    AddEditForm
  },
  computed: {
    toEdit () {
      return this.$route.params.id !== undefined
    },
    pageName () {
      return this.toEdit ? 'Edit Product' : 'Add Product'
    }
  },
  data () {
    return {
      API_BASE_URL: 'product',
      model: null,
      fields: [
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Product number', key: 'product_no', type: 'text' },
        { label: 'UPC', key: 'upc', type: 'text' },
        { label: 'Sort number', key: 'sort_no', type: 'number' },
        { label: 'Keywords', key: 'keywords', type: 'text', placeholder: 'Comma Separated Keywords' }
      ]
    }
  },
  mounted () {
    this.fetchAllCategories()
    if (this.toEdit) {
      this.fetch()
    } else {
      this.model = new Product()
    }
  },
  methods: {
    fetchAllCategories () {
      this.$store.dispatch('fetchAllCategories')
        .then((result) => {
          if (!result.data.categories.length) {
            this.$router.push('/categories')
            this.$toast.error('Please create categories first')
          }
          this.fields.splice(3, 0, { label: 'Category', key: 'category_id', type: 'select', options: result.data.categories })
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    fetch () {
      this.$store.dispatch(this.API_BASE_URL + '/get', this.$route.params.id)
        .then((result) => {
          this.model = new Product(result.product)
        })
        .catch((err) => this.$helper.catchHandler(err))
      return null
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Products/AddEdit.vue